import * as constants from '../constants/actions'

import initialState from './initialState'

function uiReducer(state = initialState.ui, action) {
  switch (action.type) {
    case constants.UPDATE_HEADER_TITLE:
      document.title = action.title
      return {
        ...state,
        headerTitle: action.title,
      }
    case constants.SHOW_HEADER_LOGIN:
      return {
        ...state,
        headerShowLogin: true,
      }
    case constants.HIDE_HEADER_LOGIN:
      return {
        ...state,
        headerShowLogin: false,
      }
    case constants.API_GET_OVERVIEW_DATA_SUCCESS:
      return {
        ...state,
        newOrganisationId: null,
      }
    case constants.API_CREATE_ORGANISATION_SUCCESS:
      return {
        ...state,
        newOrganisationId: action.organisation.uuid,
      }
    case constants.TOGGLE_ARCHIVED:
      return {
        ...state,
        showArchived: !state.showArchived,
      }
    default:
      return state
  }
}

export default uiReducer



// WEBPACK FOOTER //
// ./src/reducers/uiReducer.js